// extracted by mini-css-extract-plugin
module.exports = {"container":"PayFabricPaymentsSDK_container__1b9-7"};